import { Button, Stack } from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';

interface DrawerItemProps {
  active?: boolean;
  onClickCallback?: () => void;
  children?: React.ReactNode;
}

export default function DrawerItem({
  active = false,
  onClickCallback = () => {},
  children,
}: Readonly<DrawerItemProps>) {
  return (
    <Stack
      component='li'
      direction='row'
      sx={{
        alignItems: 'center',
        backgroundColor: active ? 'rgba(70, 122, 77, 0.08)' : 'transparent',
        '&:hover': {
          textDecoration: 'underline',
          color: active ? 'primary.main' : 'text.primary',
          width: '100%',
        },
      }}
    >
      <Button
        variant='text'
        endIcon={
          active && (
            <CheckIcon
              fontSize='inherit'
              data-testid='check-icon'
              sx={{
                color: 'primary.main',
              }}
            />
          )
        }
        sx={{
          fontWeight: active ? 700 : 400,
          marginBottom: 0,
          paddingLeft: 2,
          paddingRight: 4,
          paddingY: 1.5,
          lineHeight: '150%',
          color: active ? 'primary.main' : 'text.primary',
          textDecoration: 'none',
          width: '100%',
          '& .MuiButton-endIcon': {
            position: 'absolute',
            right: '1rem',
          },
        }}
        onClick={() => onClickCallback()}
      >
        {children}
      </Button>
    </Stack>
  );
}
